import { useState } from "react";
import { billingApi } from "../api/businessData.js";

const PLAN_DESCRIPTIONS = [
  { id: "basic", name: "Basic", price: "30€/mėn.", limit: "10 sąmatų per mėnesį" },
  { id: "pro", name: "Pro", price: "70€/mėn.", limit: "40 sąmatų per mėnesį" },
  { id: "ultimate", name: "Ultimate", price: "250€/mėn.", limit: "Neribotai sąmatų" },
];

export function PaywallScreen({ message }) {
  const [loadingPlan, setLoadingPlan] = useState(null);
  const [error, setError] = useState("");

  async function choosePlan(planId) {
    setError("");
    setLoadingPlan(planId);
    try {
      const { redirectUrl } = await billingApi.checkoutPlan(planId);
      window.location.href = redirectUrl;
    } catch (e) {
      setError(e.message || "Nepavyko pradėti mokėjimo. Bandykite dar kartą.");
      setLoadingPlan(null);
    }
  }

  return (
    <div style={{ minHeight: "100vh", background: "#F5F6FA", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ maxWidth: 720, width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ fontWeight: 900, fontSize: 22, color: "#735DFF", letterSpacing: 1 }}>SANNAMAI</div>
          <p style={{ fontSize: 14, color: "#383853", marginTop: 8 }}>
            {message || "Jūsų bandomasis laikotarpis pasibaigė. Pasirinkite planą, kad tęstumėte."}
          </p>
        </div>

        {error && <div style={{ textAlign: "center", color: "#735DFF", fontSize: 13, marginBottom: 16 }}>{error}</div>}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
          {PLAN_DESCRIPTIONS.map((plan) => (
            <div key={plan.id} style={{ background: "#fff", borderRadius: 14, padding: 24, boxShadow: "0 2px 12px rgba(0,0,0,0.06)", textAlign: "center" }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: "#1C1C1C", marginBottom: 4 }}>{plan.name}</div>
              <div style={{ fontSize: 22, fontWeight: 900, color: "#735DFF", marginBottom: 8 }}>{plan.price}</div>
              <div style={{ fontSize: 13, color: "#383853", marginBottom: 20 }}>{plan.limit}</div>
              <button
                onClick={() => choosePlan(plan.id)}
                disabled={loadingPlan !== null}
                className="w-full px-4 py-2 text-sm font-semibold rounded-lg bg-ral3000 text-white hover:bg-ral3000-dark disabled:opacity-60"
              >
                {loadingPlan === plan.id ? "Nukreipiama..." : "Pasirinkti"}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
